import { AUTH_API, handleApiError } from '../../utils/axios';

export const getClients = async (search, unpaged) => {
  try {
    const url = unpaged
      ? `/api/v1/clients?search=${search.search}`
      : `/api/v1/clients?page=${search.page}&size=${search.size}&search=${search.search}`;
    const { data } = await AUTH_API.get(url);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getClient = async (clientId) => {
  try {
    const { data } = await AUTH_API.get(`/api/v1/clients/${clientId}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const createClient = async (client) => {
  try {
    const { data } = await AUTH_API.post(`/api/v1/clients`, client);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateClient = async (client) => {
  try {
    const { data } = await AUTH_API.put(`/api/v1/clients/${client.id}`, client);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
